import * as THREE from 'three';

/**
 * Recursively disposes of all Three.js resources in a scene.
 * Call this in useEffect cleanup to prevent GPU memory leaks.
 */
export function disposeScene(scene: THREE.Scene, renderer: THREE.WebGLRenderer): void {
  scene.traverse((object) => {
    if (object instanceof THREE.Mesh) {
      if (object.geometry) {
        object.geometry.dispose();
      }
      disposeMaterial(object.material);
    } else if (object instanceof THREE.Line) {
      if (object.geometry) {
        object.geometry.dispose();
      }
      disposeMaterial(object.material);
    } else if (object instanceof THREE.Points) {
      if (object.geometry) {
        object.geometry.dispose();
      }
      disposeMaterial(object.material);
    } else if (object instanceof THREE.Sprite) {
      disposeMaterial(object.material);
    }
  });

  renderer.dispose();
}

function disposeMaterial(material: THREE.Material | THREE.Material[]): void {
  if (Array.isArray(material)) {
    material.forEach(m => disposeSingleMaterial(m));
  } else {
    disposeSingleMaterial(material);
  }
}

function disposeSingleMaterial(material: THREE.Material): void {
  material.dispose();

  // Dispose textures on the material
  const mat = material as any;
  if (mat.map) mat.map.dispose();
  if (mat.lightMap) mat.lightMap.dispose();
  if (mat.bumpMap) mat.bumpMap.dispose();
  if (mat.normalMap) mat.normalMap.dispose();
  if (mat.specularMap) mat.specularMap.dispose();
  if (mat.envMap) mat.envMap.dispose();
}
